const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the category collection component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('categoryCollection', ['Application', 'AccessHelper', '$location', function (Application, AccessHelper, $location) {
  return {
    restrict: 'E',
    scope: {},
    template: require('../../templates/directives/category-collection.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.params = Application.navigation.getUrlParameters();
      self.allowance = {
        settings: AccessHelper.isAllowed(['admin', 'settings'], null, ['admin']),
      };

      if (!self.allowance.settings || Application.access.role !== 'admin') {
        Application.navigation.goTo('/explore');
        return;
      }
      self.language;
      self.routeParameters = Application.navigation.getRouteParameters();
      var page = self.routeParameters.type;

      // Temporary - as we expand the api usefulness we can open this up without the lil requisite
      self.flags = Application.features.flags();
      self.showApiApplication = (self.flags.linkedin_learning || self.flags.open_api);

      // For temporary use until open to clients
      self.showTransfer = false;
      window.accessTransfer = function(item) {
        if (item === 'continuadmin') {
          self.showTransfer = true;
          $scope.$apply();
        }
      };

      self.refresh = null;
      
      self.navTab = function(tab) {
        var name;
        var currentTab = tab;
        switch(tab) {
          case 'categories':
          case 'locations':
          case 'departments':
          case 'teams':
          case 'grades':
          case 'customCopy':
          case 'groups':
          case 'skills':
          case 'integrations':
          case 'profiles':
          case 'seats':
          case 'theme':
            name = name || tab;
            break;
          case 'levels':
          case 'organization-levels':
            currentTab = 'org_levels';
            name = 'organization-levels';
            break;
          case 'org_levels':
            name = 'organization-levels';
            break;
          case 'transfer':
            if (!self.showTransfer) {
              return;
            }
            name = 'transfer';
            break;
          case 'application-tokens':
          case 'api_applications':
            if (!self.showApiApplication) {
              return;
            }
            currentTab = 'api_applications';
            name = 'application-tokens';
            break;
        }

        if (!name) {
          return;
        }

        $location.path('/overview/settings/' + name);
        self.currentTab = currentTab;
      };

      if (page) {
        self.navTab(page);
      }

    }],
    controllerAs: 'categories'
  }
}]);
